import { useMemo } from 'react';
import { Abnormality } from '../types/diagnostic';
import { useSelector } from 'react-redux';
import { definitionsSelector } from '../selectors/diagnostic.selectors';
import { useTypedAbnormalities } from './useDefinitionsToAbnormalities';

export const useAbnormalityByCode = () => {
  const allAvailableDefinitions = useSelector(definitionsSelector);
  const allTypedAbnormalities = useTypedAbnormalities(allAvailableDefinitions);
  return useMemo(() => {
    return allTypedAbnormalities.reduce((acc, abnormality) => {
      acc[abnormality.code] = abnormality;
      return acc;
    }, {} as Record<string, Abnormality>);
  }, [allTypedAbnormalities]);
};
